module.exports = __webpack_public_path__ + "img/icon.097f959b.png";